import axios from "axios";
import TokenService from "@/service/token.service.js";
import Vue from "vue";
import VueAxios from "vue-axios";

const ApiService = {
    init() {
        Vue.use(VueAxios, axios);
        Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL + "admin";

        Vue.axios.defaults.headers.common = {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/json",
            "Content-Type": "application/json",
            Language: "ro",
            "Accept-Language": "ro",
            Authorization: `Bearer ${TokenService.get()}`
        };

        this.registerInterceptors();
        return this;
    },
    registerInterceptors() {
        var self = this;
        // On request
        Vue.axios.interceptors.request.use(
            function(config) {
                Vue.prototype.$Progress.start();
                return config;
            },
            function(error) {
                return Promise.reject(error);
            }
        );
        // On response
        Vue.axios.interceptors.response.use(
            function(response) {
                Vue.prototype.$Progress.finish();
                return response;
            },
            function(error) {
                Vue.prototype.$Progress.finish();
                if (!error.response) {
                    Vue.toasted.show(error.message, { type: "error" });
                } else if (error.response.status === 401) {
                    // 401 => Unauthorized
                    TokenService.removeAll();
                    self.resetHeaders();
                    window.location.href = `${
                        process.env.VUE_APP_URL_AUTH
                    }/login`;
                } else {
                    return Promise.reject(error);
                }
            }
        );
    },
    resetHeaders() {
        Vue.axios.defaults.headers.common = {};
    },
    get(resource, params) {
        return Vue.axios.get(`${resource}`, params);
    },
    post(resource, params) {
        return Vue.axios.post(`${resource}`, params);
    },
    update(resource, params) {
        return Vue.axios.put(`${resource}`, params);
    },
    delete(resource, params) {
        return Vue.axios.delete(`${resource}`, params);
    },
    customRequest(data) {
        return Vue.axios(data);
    }
};

export default ApiService;
